"use client";

import Error from "next/error";
import { useEffect } from "react";
import { trackClientError } from "@/lib/trackClientError";
import { onDatadogRumReady } from "@/lib/analytics/datadogRum";

export default function GlobalError({ error }) {
  useEffect(() => {
    trackClientError({
      error,
      source: "global_error_boundary",
    });

    // Report to Datadog RUM for correlation with session replays and traces
    onDatadogRumReady((datadogRum) => {
      datadogRum.addError(error, {
        source: "global-error-boundary",
      });
    });
  }, [error]);

  return (
    <html>
      <body>
        <Error />
      </body>
    </html>
  );
}
